import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { NotFoundSection } from 'components/sections/NotFoundSection';

export const NotFoundPage = () => {
  return (
    <div className="min-h-[100vh] flex flex-col justify-between">
      <main className="pt-20 h-full">
        <Header />
        <NotFoundSection />
      </main>
      <Footer />
    </div>
  );
};
